import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@src/store/metricsChartContainer/selectors';
import { getInvertedPercentageMetricByKey } from '@src/utils/metrics/metricHelpers';

export function scrollChartToView(selectedMetric) {
  const chartId = getInvertedPercentageMetricByKey({
    metricKey: selectedMetric,
    defaultValue: selectedMetric,
  });
  const metricsCardToMove: any = document.getElementById(`${chartId}`);
  if (metricsCardToMove) {
    setTimeout(() => {
      // scrolling has issues in chrome
      metricsCardToMove.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }, 0);
  }
}

function useAutoScroll({ enabled }) {
  const selectedMetric = useSelector(selectedMetricSelector);

  const scrollToSelectedMetric = useCallback(() => {
    scrollChartToView(selectedMetric);
  }, [selectedMetric]);

  // only on first render
  useEffect(() => {
    if (enabled) {
      scrollToSelectedMetric();
    }
  }, [enabled]);

  return { scrollToSelectedMetric };
}

export default useAutoScroll;
